const REDUCER = "@SLIDER/";

const actions = {
  GET_LIST_SLIDER: `${REDUCER}GET_LIST_SLIDER`,
  SET_LIST_SLIDER: `${REDUCER}SET_LIST_SLIDER`,
  SET_IS_LOADING: `${REDUCER}SET_IS_LOADING`,
  SET_CURRENT_SLIDER: `${REDUCER}SET_CURRENT_SLIDER`,
};
export default actions;
